import Styles from './PageFooter.module.scss';

function PageFooter({ children }: Readonly<{ children: React.ReactElement | React.ReactElement[] }>): React.ReactElement {
    return (
        <div className={Styles.footer}>
            {children}
        </div>
    );
}

function FooterActions({ children }: Readonly<{ children?: React.ReactElement | React.ReactElement[] }>): React.ReactElement {
    return (
        <div className={Styles.actions}>
            {children}
        </div>
    );
}

function FooterButtons({ children }: Readonly<{ children: React.ReactElement | React.ReactElement[] }>): React.ReactElement {
    return (
        <div className={Styles.rightButtons}>
            {children}
        </div>
    );
}

export {
    FooterActions,
    FooterButtons, PageFooter,
};
